<template>
  <!-- 水位管理-->
  <div>
    <a-card style="width: 100%">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="12">
            <a-col :md="6" :sm="24">
              <a-form-item label="选择时间">
                <a-date-picker :show-time="{ format: 'YYYY-MM-DD' }" format="YYYY-MM-DD" placeholder="选择时间"
                  @change="OnChange" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item>
                <a-button type="primary" @click="queryList">查询</a-button>
                <a-button type="primary" style="margin-left: 8px" @click="exportHandle()">导出</a-button>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row> </a-row>
        </a-form>
      </div>
      <a-table :columns="columns" :data-source="list" :pagination="false"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/common'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      columns: [
        {
          title: '时间',
          dataIndex: 'time',
          align: 'center'
        },
        {
          title: '水池水位（m）',
          children: [
            {
              title: '1#清水池',
              dataIndex: 'waterLevelsA',
              align: 'center'
            },
            {
              title: '2#清水池',
              dataIndex: 'waterLevelsB',
              align: 'center'
            },
            {
              title: '3#清水池',
              dataIndex: 'waterLevelsC',
              align: 'center'
            },
            {
              title: '4#清水池',
              dataIndex: 'waterLevelsD',
              align: 'center'
            }
          ]
        }
      ],
      exportDataUrl: 'pipe-network/water_works_report/export/days/type',
      exportFileName: '水位报表.xlsx',
      queryUrl: '/pipe-network/pipes/getDeviceInfoDate',
      query: {
        sTime: '',
        type: 4
      }
    }
  },
  computed: {},
  mounted () { },
  created () {
    // this.queryList()
  },
  methods: {
    OnChange (date, dateString) {
      this.query.sTime = dateString
    },
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          console.log(data);
          this.dataListLoading = false
          if (this.needPage) {
            data.map((item) => {
              if (item.waterQuality) {
                console.log(item);
                item.waterLevelsA = item.waterQuality.waterLevelsA
                item.waterLevelsB = item.waterQuality.waterLevelsB
                item.waterLevelsC = item.waterQuality.waterLevelsC
                item.waterLevelsD = item.waterQuality.waterLevelsD
              }
            })
            this.list = data || []
            console.log(this.list)
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/ .ant-form-item {
  margin-bottom: 12px;
}
</style>
